import { useEffect, useRef, useState } from "react";
import { Button } from "./ui/button";

export default function SignaturePad({ onChange, testid = "signature-pad" }) {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.strokeStyle = "#1A1A1A";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, c.width, c.height);
  }, []);

  const pos = (e) => {
    const c = canvasRef.current;
    const rect = c.getBoundingClientRect();
    const t = e.touches?.[0];
    const x = (t ? t.clientX : e.clientX) - rect.left;
    const y = (t ? t.clientY : e.clientY) - rect.top;
    return { x: (x * c.width) / rect.width, y: (y * c.height) / rect.height };
  };

  const start = (e) => {
    e.preventDefault();
    setDrawing(true);
    setEmpty(false);
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
  };
  const end = () => {
    if (!drawing) return;
    setDrawing(false);
    const url = canvasRef.current.toDataURL("image/png");
    onChange?.(url);
  };
  const clear = () => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange?.("");
  };

  return (
    <div className="space-y-2">
      <div className="doc-paper p-2 relative" data-testid={testid}>
        <canvas
          ref={canvasRef}
          width={600}
          height={180}
          className="w-full h-40 touch-none cursor-crosshair rounded-sm"
          onMouseDown={start}
          onMouseMove={move}
          onMouseUp={end}
          onMouseLeave={end}
          onTouchStart={start}
          onTouchMove={move}
          onTouchEnd={end}
        />
        {empty && (
          <span className="absolute left-4 top-4 text-xs text-muted-foreground pointer-events-none">Assine aqui</span>
        )}
      </div>
      <div className="flex justify-end">
        <Button variant="outline" size="sm" onClick={clear} data-testid="clear-signature-btn">Limpar</Button>
      </div>
    </div>
  );
}
